import api from './client';

export const getPosts = (params = {}) =>
  api.get('/api/posts', { params }).then(res => res.data);

export const getPostBySlug = (slug) =>
  api.get(`/api/posts/${slug}`).then(res => res.data);

export const getAllTags = () =>
  api.get('/api/posts/tags').then(res => res.data);
